$shm_hitalama_process_monitor $mol_book2
	menu_title \Процессы
	spread? \
	menu_tools /
		<= Exclude_filter $mol_pick
			trigger_content /
				<= Exclude_icon $mol_icon_filter_off
			bubble_content /
				<= Exclude_label $mol_view
					sub / \Исключить
				<= Exclude_input $mol_string
					hint \Подстрока
					value? <=> exclude_substr? \
	pages /
		<= Menu $mol_page
			Title => Menu_title
			title <= menu_title
			Tools => Menu_tools
			tools <= menu_tools
			body /
				<= Menu_filter $mol_search
					query? <=> menu_filter? \
				<= Menu_links $mol_list
					rows <= menu_links /$mol_view
						<= Menu_item*0 $mol_view
							attr *
								^
								shm_hitalama_process_monitor_current <= detail_current* false
							sub /
								<= Menu_detail* $mol_button_minor
									click? <=> detail_click*? null
									sub /
										<= Process_duration* $mol_paragraph
											title <= process_duration* \
								<= Menu_widget* $mol_button_minor
									click? <=> widget_click*? null
									sub /
										<= Menu_link_status* $mol_view
											style *
												^
												color <= process_status_color*
												backgroundColor <= process_status_tint*
											sub / <= process_status*
										<= Menu_link_title* $mol_dimmer
											needle <= menu_filter
											haystack <= spread_title*
		<= spread_current
	spread_current null
	spread_title* \
	detail_current* false
	process_status_color* \
	process_status_tint* \
	Page* $shm_hitalama_process_monitor_detail
		key <= key*
		close? <=> detail_close*? null
	key* <= key_default \
	detail_close*? null
	exclude_substr? \
	Menu_node_title* \
	Menu_node_content* /
	Menu_node_branch* $shm_hitalama_process_monitor_branch
		caption <= Menu_node_title*
		expanded? <=> process_expanded*? true
		Tools <= Menu_item*
		content <= Menu_node_content* /
